import {
  CreatePaylinkWithApiDto,
  Paylink,
  ShallowEnrichedPaylink,
  UpdatePaylinkWithApiDto,
} from '@heliofi/common';
import { ApiAdapter } from '../ApiAdapter';

export class PaylinkSDK {
  constructor(private apiAdapter: ApiAdapter) {}

  async create(
    createPaylinkDto: CreatePaylinkWithApiDto,
  ): Promise<ShallowEnrichedPaylink> {
    return this.apiAdapter.post(
      '/paylink/create/api-key',
      createPaylinkDto,
      'Failed to create paylink',
    );
  }

  async update(
    paylinkId: string,
    updatePaylinkDto: UpdatePaylinkWithApiDto,
  ): Promise<Paylink> {
    return this.apiAdapter.patch(
      `/paylink/${paylinkId}/api-key`,
      updatePaylinkDto,
      'Failed to update paylink',
    );
  }

  async disable(paylinkId: string): Promise<boolean> {
    return this.apiAdapter.patch(
      `/paylink/${paylinkId}/disable/api-key`,
      undefined,
      'Failed to disable paylink',
    );
  }
}
